import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { useLightMode } from "src/common/hooks/lightMode";
import { Loading } from "src/components";
import { useTranslate } from "@tolgee/react";

const TravelerTracker = React.lazy(() => import("./TravelerTracker"));

function TravelerTrackerPage(props) {
  const { t } = useTranslate();
  usePageInit(`${t({ key: "common.smartPortal", defaultValue: "Smart Portal" })} - ${t({ key: "travelerTracker.title", defaultValue: "Traveler Tracker" })}`);
  const { lightMode } = useLightMode();
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={
            props.isGlobalRiskMap
              ? t({ key: "travelerTracker.globalRiskMap.loading", defaultValue: "Loading Risk Map" })
              : t({ key: "travelerTracker.loading", defaultValue: "Loading Traveler Tracker" })
          }
        />
      }
    >
      <TravelerTracker
        {...props}
        // Use a key to force the map to remount when changing lightmode
        key={lightMode}
        lightMode={lightMode}
      />
    </Suspense>
  );
}

export default TravelerTrackerPage;
